import React from "react";

export default class Footer extends React.Component<any, any> {
    render() {
        return (
            <>
                <footer id="footer">
                    {/*<div className="footer-top">*/}
                    {/*    <div className="container">*/}
                    {/*        <div className="row">*/}
                    {/*            <div className="col-lg-3 col-md-6">*/}
                    {/*                <div className="footer-info">*/}
                    {/*                    <img src={'/assets/logo-w.png'} width={183} style={{marginLeft: -15}}/>*/}
                    {/*                    <p style={{color: 'gray'}}>*/}
                    {/*                        <strong>사업자등록번호</strong> 559-87-01690<br/>*/}
                    {/*                        <strong>대표이사</strong> 김동욱 <br/>*/}
                    {/*                        <strong>주소</strong> 경기도 안양시 동안구 흥안대로 445 606호*/}
                    {/*                    </p>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="container">
                        <div className="copyright">
                            &copy; Copyright <strong><span>RIMOCAST Corp.</span></strong>. All Rights Reserved
                        </div>
                    </div>
                </footer>

                <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i
                    className="bi bi-arrow-up-short"></i></a>
            </>
        );
    }
}
